import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { useKeycloak } from '@eggplant/context'
import type {
  Error,
  SmtpSettings
} from '@eggplant/types'
import type { ReactElement } from 'react'

interface Props {
  children?: () => ReactElement
  onSuccess?: () => void
  onError?: (error: Error) => void
  params?: SmtpSettings
}

const PostConnectionRequest = ({
  children,
  onSuccess,
  onError,
  params
}: Props) => {
  const { keycloak: keycloakInstance } = useKeycloak()
  const url = `${keycloakInstance.authServerUrl}/realms/${keycloakInstance.realm}/dai/v1//smtp/connection`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='post'
      onError={onError}
      onSuccess={onSuccess}
      params={params}
      url={url}
    />
  )
}

export default PostConnectionRequest
